import { EXTERNAL_LOGIN_PATH } from 'utils/navigation/urls';

import { getKeycloakConfig, getLogoutEndpoint } from './config';

export const DEFAULT_LOGOUT_PATH = '/login';

const buildLogoutUrl = ({
  issuer,
  clientId,
  postLogoutRedirectUri,
  idToken,
}: {
  issuer: string;
  clientId: string;
  postLogoutRedirectUri: string;
  idToken?: string | null;
}): string => {
  const url = new URL(getLogoutEndpoint(issuer));

  url.searchParams.set('client_id', clientId);
  url.searchParams.set('post_logout_redirect_uri', postLogoutRedirectUri);

  if (idToken) {
    url.searchParams.set('id_token_hint', idToken);
  }

  return url.toString();
};

export const createKeycloakLogoutRedirect = (idToken?: string | null, origin = window.location.origin, loginPath = EXTERNAL_LOGIN_PATH): string => {
  const config = getKeycloakConfig(origin);

  return buildLogoutUrl({
    issuer: config.issuer,
    clientId: config.clientId,
    postLogoutRedirectUri: `${origin}${loginPath}`,
    idToken,
  });
};

export const endKeycloakSession = (idToken?: string | null, origin = window.location.origin, loginPath = EXTERNAL_LOGIN_PATH) => {
  window.location.assign(createKeycloakLogoutRedirect(idToken, origin, loginPath));
};
